export const UPDATE_PRIVATE_MEDIA = 'UPDATE_PRIVATE_MEDIA'
export const UPDATE_PRIVATE_MEDIA_SUCCESS = 'UPDATE_PRIVATE_MEDIA_SUCCESS'
export const UPDATE_PRIVATE_MEDIA_FAILED = 'UPDATE_PRIVATE_MEDIA_FAILED'

export const GET_PRIVATE_MEDIA = 'GET_PRIVATE_MEDIA'
export const GET_PRIVATE_MEDIA_SUCCESS = 'GET_PRIVATE_MEDIA_SUCCESS'
export const GET_PRIVATE_MEDIA_FAILED = 'GET_PRIVATE_MEDIA_FAILED'
